import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { POSTS } from "../../lib/blog";

export const BlogPreview = () => {
  const featured = POSTS.slice(0, 3);
  return (
    <section
      data-testid="blog-preview-section"
      className="py-24 md:py-32 max-w-7xl mx-auto px-6 lg:px-8"
    >
      <div className="grid lg:grid-cols-12 gap-10 mb-14 items-end">
        <div className="lg:col-span-7">
          <div className="label-eyebrow text-brand-terracotta mb-5">Latest insights</div>
          <h2 className="font-display text-4xl sm:text-5xl tracking-tight font-medium text-brand-ink">
            Australian mortgage guides — straight from the broker&apos;s desk.
          </h2>
        </div>
        <div className="lg:col-span-3 lg:col-start-10 lg:text-right">
          <Link
            to="/blog"
            data-testid="home-view-all-articles"
            className="inline-flex items-center gap-2 text-brand-eucalyptus font-medium hover:text-brand-terracottaDark"
          >
            View all articles
            <ArrowRight className="h-4 w-4" strokeWidth={1.8} />
          </Link>
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-6">
        {featured.map((p) => (
          <Link
            key={p.slug}
            to={`/blog/${p.slug}`}
            data-testid={`home-blog-card-${p.slug}`}
            className="group rounded-2xl overflow-hidden border border-border bg-card transition-all duration-300 hover:-translate-y-1 hover:shadow-md flex flex-col"
          >
            <div className="aspect-[16/10] overflow-hidden">
              <img
                src={p.image}
                alt={p.title}
                className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-700"
              />
            </div>
            <div className="p-6 flex flex-col flex-1">
              <div className="flex items-center gap-3 text-[11px] uppercase tracking-widest text-brand-eucalyptus/80">
                <span>{p.category}</span>
                <span className="h-1 w-1 rounded-full bg-brand-ink/30" />
                <span className="flex items-center gap-1.5">
                  <Clock className="h-3 w-3" strokeWidth={1.6} />
                  {p.readMinutes} min
                </span>
              </div>
              <h3 className="mt-4 font-display text-xl tracking-tight text-brand-ink group-hover:text-brand-terracotta transition-colors">
                {p.title}
              </h3>
              <p className="mt-3 text-sm text-brand-ink/65 leading-relaxed flex-1">
                {p.excerpt}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};
